<template>
  <div class="wrapper wrapper-content animated fadeInRight">
    <el-form
      :model="detailInfo"
      ref="detailInfo"
      label-width="0px"
      class="demo-dynamic form-horizontal detailPage"
    >
      <el-tabs type="border-card">
        <el-tab-pane
          :label="$t('message.' + langItem.langCode)"
          v-for="(langItem, index) in detailInfo.langMaps"
          :key="index"
        >
          <div class="panel-body">
            <div class="ibox-content">
              <div class="form-group">
                <label class="col-sm-2 control-label">
                  Text
                </label>
                <div class="col-sm-10">
                  <el-form-item
                    :prop="'langMaps.' + index + '.remark'"
                    :rules="{
                      required: true,
                      message: $t('message.required'),
                      trigger: 'blur'
                    }"
                  >
                    <ckeditor :editor="editor"  @ready="onReady" v-model="langItem.remark" :config="editorConfig" ></ckeditor>
                  </el-form-item>
                </div>
              </div>
              <div class="hr-line-dashed"></div>
              <div class="form-group">
                <div class="col-sm-12">
                  <div class="pull-right">
                    <el-button
                      type="primary"
                      @click="checkEvent()"
                      >Save and Publish</el-button>
                    <el-button @click="showWarning()">{{
                      $t("message.Cancel")
                    }}</el-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-form>
  </div>
</template>
<script>
import config from "../config";
import ClassicEditor from '@ckeditor/ckeditor5-build-decoupled-document';
const upload = require('../upload')

export default {
  mixins: [config.globalMixin],
  data() {
    return {
      editor: ClassicEditor,
      editorConfig: {
        toolbar: [ 'Heading', 'bold', 'italic','underline','Link', 'bulletedList', 'numberedList' ],
          // The configuration of the editor.
      },
      detailInfo: {
        langMaps: [],
      },
      categoryList:[]
    };
  },
  computed: {
    _language() {
      return this.$store.state.userInfo.langCode;
    }
  },
  watch: {
    _language: function() {
      this.setObj();
    },
    detailInfo: {
      handler: function() {
        this.$store.state.edit = true;
      },
      deep: true
    }
  },
  created() {
    this.setObj();
    var obj = [];
    for (var i = 0; i < this.$store.state.userInfo.language.length; i++) {
      obj.push({
        langCode: this.$store.state.userInfo.language[i].langCode,
        remark:"",
      });
    }
    this.$set(this.detailInfo, "langMaps", obj);
    this.init();
  },
  mounted() {
  },
  methods: {
    onReady( editor )  {
        // Insert the toolbar before the editable area.
        editor.ui.getEditableElement().parentElement.insertBefore(
            editor.ui.view.toolbar.element,
            editor.ui.getEditableElement()
        );
    },
    setObj: function() {
      this.statusObj = [
        {
          value: 1,
          label: this.$i18n.t("message.Active")
        },
        {
          value: 0,
          label: this.$i18n.t("message.Inactive")
        }
      ];
    },
    async init() {
      var that = this;
      let obj = this.getAuthObj();
      obj.apiUrl = this.apiConfig.termsConditonsDetail;
      let data = await this.$store.dispatch("apiEvent", obj);
      if(data == "000104"){
        this.timeoutEvent();
        return;
      }
      if (!data) return;
      if(!data.data.result){
        data.data.result = {}
      }
      if(!data.data.result.langMaps){
        var obj2 = [];
        for (var i = 0; i < this.$store.state.userInfo.language.length; i++) {
          obj2.push({
            langCode: this.$store.state.userInfo.language[i].langCode,
            remark:"",
          });
        }
        data.data.result.langMaps = obj2;
      }
      this.$set(this, "detailInfo", data.data.result);
      
      setTimeout(function() {
        that.$store.state.edit = false;
      },500);
    },
    checkEvent: function() {
      this.$refs["detailInfo"].validate(valid => {
        if (valid) {
          this.submit();
        } else {
          this.$toastr.w(this.$i18n.t("message.fillRequired"));
          return false;
        }
      });
    },
    async submit() {
      try {
        let obj = this.getAuthObj();
        obj.status = this.detailInfo.status;
        obj.langMaps = this.detailInfo.langMaps;
          
        var data;
        obj.apiUrl = this.apiConfig.termsConditonsUpdate;
        data = await this.$store.dispatch("apiEvent", obj);
      if(data == "000104"){
        this.timeoutEvent();
        return;
      }
        if (!data) return;
        if (data.data.status_code === "0") {
          this.$store.state.edit = false;
          this.$message({
            message: 'Save Success',
            type: 'success'
          });
          this.init()
        }
      } catch (err) {}
    },
  }
};
</script>
